<template>
  <Modal class="modals" v-model="dataMap.modalP" :footer-hide="true" :mask-closable="false" title="下载中心" width="1000">

    <Form :model="formInline" inline :label-width="80">
      <FormItem prop="module" label="模块">
        <Input type="text" v-model="formInline.module" placeholder="请输入模块" style="width:240px">
        </Input>
      </FormItem>
      <FormItem prop="subModule" label="子模块">
        <Input type="text" v-model="formInline.subModule" placeholder="请输入子模块" style="width:240px">
        </Input>
      </FormItem>
      <FormItem prop="processStatus" label="任务状态">
        <Select v-model="formInline.processStatus" placeholder="请选择任务状态" clearable style="width:240px">
          <Option v-for="item in processStatusList" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
      </FormItem>
      <FormItem prop="createTime" label="创建时间">
        <DatePicker type="datetimerange" v-model="formInline.createTime" format="yyyy-MM-dd" clearable
          placeholder="创建时间" style="width: 240px" />
      </FormItem>
      <FormItem>
        <Button type="primary" @click="handleSearch">查询</Button>
      </FormItem>
    </Form>
    <Table border :columns="columns" :data="data" :loading="loading" height="500">
      <template #processStatus="{ row }">
        <span :class="{
          'text-info': row.processStatus == 1,
          'text-success': row.processStatus == 2,
          'text-error': row.processStatus == 3,
          'text-danger': row.processStatus === 4
        }">
          {{ row.processStatusDesc }}
        </span>
      </template>
      <template #action="{ row, index }">
        <Button type="text" size="small" style="margin-right: 5px;color: #1890FF" :disabled="!row.url"
          @click="downloadFun(row)">下载</Button>
        <Button type="text" size="small" style="color: #FF4D4F" @click="deleteFun(row)">删除</Button>
      </template>

    </Table>
    <Page style="margin-top: 10px;text-align: right;" :total="total" show-total :page-size="pageSize" show-elevator
      @on-change="handleChange" @on-page-size-change="handlePageSizeChange" />
    <div slot="footer" style="text-align:center;margin-top: 20px;">
      <Row type="flex" justify="center">
        <Button style="margin-right:30px" @click="cancel">关闭</Button>
      </Row>
    </div>
  </Modal>
</template>
<script setup>
import { queryDownloadProgressList, deleteDownloadProgress } from '@/api/user';
import { Table, Page, Message, Modal, Select, Option, Form, FormItem, Input, Button, DatePicker } from "view-ui-plus";
import { reactive, toRefs, ref, defineExpose } from 'vue';
import { Domain_Url_Env } from '@/config/index';

const formInline = reactive({
  module: '',
  subModule: '',
  processStatus: '',
  createTime: [],
})
const total = ref(0)
const page = ref(1)
const pageSize = ref(15)
const columns = [
  {
    title: '任务ID',
    key: 'taskId',
    minWidth: 160,
  },
  {
    title: '文件名',
    key: 'fileName',
    minWidth: 240,
  },
  {
    title: '模块',
    key: 'module',
    width: 200,
  },
  {
    title: '子模块',
    key: 'subModule',
    minWidth: 200,
  },
  {
    title: '状态',
    key: 'processStatusDesc',
    width: 140,
    slot: 'processStatus',
  },
  {
    title: '创建人',
    key: 'creator',
    minWidth: 120,
  },
  {
    title: '创建时间',
    key: 'createTime',
    minWidth: 180,
  },
  {
    title: '操作',
    slot: 'action',
    width: 140,
    fixed: 'right',
    align: 'center'
  }
]
const loading = ref(false)
const processStatusList = [
  {
    value: 0,
    label: '等待中'
  },
  {
    value: 1,
    label: '生成中'
  },
  {
    value: 2,
    label: '生成成功'
  },
  {
    value: 3,
    label: '生成失败'
  }
]
const dataMap = reactive({
  modalP: false,
  btnLoading: false,
})
const data = ref([
])
const downloadFun = (row) => {
  // window.open(row.url)
  window.location.href = row.url
}
const deleteFun = (row) => {
  Modal.confirm({
    type: 'warning',
    title: '提示',
    content: `确认文件${row.fileName}删除吗？`,
    okText: '确认',
    cancelText: '取消',
    onOk: () => {
      const userInfo = JSON.parse(localStorage.getItem('USERINFOSTORAGE'));
      const userId = userInfo.user.userId;
      deleteDownloadProgress({
        ids: [row.id],
        userId
      }).then(res => {
        if (!res.data.code) {
          Message.success('删除成功')
          page.value = 1
          getList()
        } else {
          Message.error(res.message || '请求异常')
        }
      }).catch(err => {
        Message.error(err.message || '请求异常')
      })
    },
  });
}
const cancel = () => {
  dataMap.modalP = false;
}

const handleChange = (val) => {
  page.value = val
  getList()
}
const handlePageSizeChange = (val) => {
  pageSize.value = val
  page.value = 1
  getList()
}
const open = () => {
  getList()
  dataMap.modalP = true;

}
const handleSearch = () => {
  page.value = 1
  data.value = []
  total.value = 0
  getList()
}
// 格式化年月日时分秒
const formatDate = (date) => {
  console.log('ormInline.createTime', formInline.createTime)
  if (!date) return ''
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()
  return `${year}-${month > 9 ? month : '0' + month}-${day > 9 ? day : '0' + day}`
}
const getList = () => {
  loading.value = true
  console.log('formInline', formInline)
  const userInfo = JSON.parse(localStorage.getItem('USERINFOSTORAGE'));
  const userId = userInfo.user.userId;
  queryDownloadProgressList({
    ...formInline,
    startTime: formInline.createTime && formInline.createTime.length ? formatDate(formInline.createTime[0]) : '',
    endTime: formInline.createTime && formInline.createTime.length ? formatDate(formInline.createTime[1]) : '',
    userId,
    sourceFrom: 1,
    page: page.value,
    pageSize: pageSize.value,
  }).then(res => {
    loading.value = false

    console.log(res)
    if (!res.data.code) {
      const dataObj = res.data.data
      data.value = dataObj.records
      total.value = dataObj.total
    } else {
      Message.error('服务异常')
    }
  }).catch(err => {
    loading.value = false
    Message.error('服务异常')
  })
}

defineExpose({
  open,
})
</script>
<style lang="less" scoped>
.message-title {
  color: #999999;
  margin-left: 100px;
  margin-bottom: 40px;
  font-size: 12px;
}

.text-info {
  color: #2db7f5;
}

.text-success {
  color: #19be6b;
}

.text-danger {
  color: #ff9900;
}

.text-error {
  color: #ed4014;
}
</style>
